// extracted by mini-css-extract-plugin
export default {"moviesGrids":"MoviesCards_moviesGrids__vFSZ4"};